import { Injectable, } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { StoresDataService } from './stores.data.service';


@Injectable()
export class CompetitorShopsResolver {
  constructor(
    private shopService: StoresDataService,
    private router: Router,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
  ): Observable<any> {
    return this.shopService.getCompetitorsShops(route.parent.params['id'])
      .pipe(catchError(() => this.router.navigateByUrl('/')));
  }
}
